// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-create-diet {
    padding: 30px;
    background-color: #A5D6A7;
    border-radius: 20px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
    width: 2000px;
    max-width: 700px;
    margin: 50px auto;
    font-family: 'Rubik', sans-serif;
  }
  
  .admin-create-diet h1 {
    text-align: center;
    color: #333;
    font-size: 32px;
    margin-bottom: 30px;
    font-weight: 700;
  }
  
  .admin-create-diet form {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  .admin-create-diet label {
    font-weight: 600;
    color: #333;
    display: block;
    font-family: 'Rubik', sans-serif;
  }
  
  .admin-create-diet .small-input {
    padding: 10px;
    height: 40px;
    border: 1px solid #ddd;
    border-radius: 10px;
    font-size: 16px;
    font-family: 'Rubik', sans-serif;
    width: 100%;
    box-sizing: border-box;
    background-color: #f9f9f9;
    transition: all 0.3s ease;
  }
  
  .admin-create-diet .large-input {
    padding: 15px;
    height: 150px;
    border: 1px solid #ddd;
    border-radius: 15px;
    font-size: 16px;
    font-family: 'Rubik', sans-serif;
    width: 100%;
    box-sizing: border-box;
    background-color: #f9f9f9;
    transition: all 0.3s ease;
    resize: vertical; 
  }
  
  .admin-create-diet input:focus,
  .admin-create-diet textarea:focus {
    border-color: #A5D6A7;
    outline: none;
    background-color: #ffffff;
    box-shadow: 0px 0px 8px rgba(76, 175, 80, 0.5);
  }
  
  .admin-create-diet button {
    background: #004D40;
    color: #fff;
    border: none;
    padding: 15px;
    border-radius: 15px;
    font-size: 18px;
    font-family: 'Rubik', sans-serif;
    cursor: pointer;
    font-weight: 600;
    width: 30%;
    margin: 0 auto;
    display: block;
    transition: all 0.3s ease;
  }
  
  .admin-create-diet button:hover {
    background: #2E7D32;
  }
  
  .admin-create-diet .cancel-btn1 {
    background: #dc3545 !important;
    color: white;
  }
  
  .admin-create-diet .success-message,
  .admin-create-diet .error-message {
    border-radius: 15px;
    padding: 12px 20px;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
  }
  
  .admin-create-diet .success-message {
    background-color: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
  }
  
  .admin-create-diet .error-message {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
  }
  
  .admin-create-diet input:hover,
  .admin-create-diet textarea:hover {
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  }
  
  @media (max-width: 768px) {
    .admin-create-diet {
      padding: 20px;
      max-width: 90%;
    }
  
    .admin-create-diet h1 {
      font-size: 24px;
    }
  
    .admin-create-diet button {
      font-size: 16px;
      padding: 12px;
    }
  }  

.success-message-container {
  position: fixed;
  top: 70px;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  pointer-events: none;
}

.success-message22 {
  color: #155724;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  padding: 12px 20px;
  border-radius: 15px;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: inline-flex;
  align-items: center;
  max-width: 60% !important;
  text-align: center;
  animation: fadeInOut 3s ease-in-out forwards;
}

.error-message22 {
  color: #d32f2f;
  background-color: #fde7e9;
  border: 1px solid #d32f2f;
  padding: 12px;
  border-radius: 10px;
  display: flex !important;
  align-items: center !important;
  gap: 8px;
  margin: 10px auto !important; 
  font-weight: 600;
  width: 40%;
  justify-content: center !important;
  text-align: center;
}

@keyframes fadeInOut {
  0% { opacity: 0; transform: translateY(-20px); }
  10% { opacity: 1; transform: translateY(0); }
  90% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-20px); }
}`, "",{"version":3,"sources":["webpack://./src/styles/CreateDietTemplatePage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;;IAEE,qBAAqB;IACrB,aAAa;IACb,yBAAyB;IACzB,8CAA8C;EAChD;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,YAAY;EACd;;EAEA;;IAEE,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;;IAEE,sCAAsC;EACxC;;EAEA;IACE;MACE,aAAa;MACb,cAAc;IAChB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,aAAa;IACf;EACF;;AAEF;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;EACV,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,KAAK,UAAU,EAAE,4BAA4B,EAAE;EAC/C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,OAAO,UAAU,EAAE,4BAA4B,EAAE;AACnD","sourcesContent":[".admin-create-diet {\n    padding: 30px;\n    background-color: #A5D6A7;\n    border-radius: 20px;\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n    width: 2000px;\n    max-width: 700px;\n    margin: 50px auto;\n    font-family: 'Rubik', sans-serif;\n  }\n  \n  .admin-create-diet h1 {\n    text-align: center;\n    color: #333;\n    font-size: 32px;\n    margin-bottom: 30px;\n    font-weight: 700;\n  }\n  \n  .admin-create-diet form {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n  \n  .admin-create-diet label {\n    font-weight: 600;\n    color: #333;\n    display: block;\n    font-family: 'Rubik', sans-serif;\n  }\n  \n  .admin-create-diet .small-input {\n    padding: 10px;\n    height: 40px;\n    border: 1px solid #ddd;\n    border-radius: 10px;\n    font-size: 16px;\n    font-family: 'Rubik', sans-serif;\n    width: 100%;\n    box-sizing: border-box;\n    background-color: #f9f9f9;\n    transition: all 0.3s ease;\n  }\n  \n  .admin-create-diet .large-input {\n    padding: 15px;\n    height: 150px;\n    border: 1px solid #ddd;\n    border-radius: 15px;\n    font-size: 16px;\n    font-family: 'Rubik', sans-serif;\n    width: 100%;\n    box-sizing: border-box;\n    background-color: #f9f9f9;\n    transition: all 0.3s ease;\n    resize: vertical; \n  }\n  \n  .admin-create-diet input:focus,\n  .admin-create-diet textarea:focus {\n    border-color: #A5D6A7;\n    outline: none;\n    background-color: #ffffff;\n    box-shadow: 0px 0px 8px rgba(76, 175, 80, 0.5);\n  }\n  \n  .admin-create-diet button {\n    background: #004D40;\n    color: #fff;\n    border: none;\n    padding: 15px;\n    border-radius: 15px;\n    font-size: 18px;\n    font-family: 'Rubik', sans-serif;\n    cursor: pointer;\n    font-weight: 600;\n    width: 30%;\n    margin: 0 auto;\n    display: block;\n    transition: all 0.3s ease;\n  }\n  \n  .admin-create-diet button:hover {\n    background: #2E7D32;\n  }\n  \n  .admin-create-diet .cancel-btn1 {\n    background: #dc3545 !important;\n    color: white;\n  }\n  \n  .admin-create-diet .success-message,\n  .admin-create-diet .error-message {\n    border-radius: 15px;\n    padding: 12px 20px;\n    font-size: 16px;\n    font-weight: 600;\n    text-align: center;\n  }\n  \n  .admin-create-diet .success-message {\n    background-color: #d4edda;\n    color: #155724;\n    border: 1px solid #c3e6cb;\n  }\n  \n  .admin-create-diet .error-message {\n    background-color: #f8d7da;\n    color: #721c24;\n    border: 1px solid #f5c6cb;\n  }\n  \n  .admin-create-diet input:hover,\n  .admin-create-diet textarea:hover {\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);\n  }\n  \n  @media (max-width: 768px) {\n    .admin-create-diet {\n      padding: 20px;\n      max-width: 90%;\n    }\n  \n    .admin-create-diet h1 {\n      font-size: 24px;\n    }\n  \n    .admin-create-diet button {\n      font-size: 16px;\n      padding: 12px;\n    }\n  }  \n\n.success-message-container {\n  position: fixed;\n  top: 70px;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  pointer-events: none;\n}\n\n.success-message22 {\n  color: #155724;\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n  padding: 12px 20px;\n  border-radius: 15px;\n  font-weight: 600;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  display: inline-flex;\n  align-items: center;\n  max-width: 60% !important;\n  text-align: center;\n  animation: fadeInOut 3s ease-in-out forwards;\n}\n\n.error-message22 {\n  color: #d32f2f;\n  background-color: #fde7e9;\n  border: 1px solid #d32f2f;\n  padding: 12px;\n  border-radius: 10px;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px;\n  margin: 10px auto !important; \n  font-weight: 600;\n  width: 40%;\n  justify-content: center !important;\n  text-align: center;\n}\n\n@keyframes fadeInOut {\n  0% { opacity: 0; transform: translateY(-20px); }\n  10% { opacity: 1; transform: translateY(0); }\n  90% { opacity: 1; transform: translateY(0); }\n  100% { opacity: 0; transform: translateY(-20px); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
